export default __webpack_public_path__ + "static/media/dollar.8a4af474.png";